module.exports = __webpack_public_path__ + "static/img/3939_phase_function_Paper_PointsHejduk_Prediction.f5a03a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3939_phase_function_Paper_PointsHejduk_Prediction.png
// module id = XdgX
// module chunks = 0